/**
 * Modal constants for Trade Finance Case Study with Modal.
 */

import { __ } from '@wordpress/i18n';
import { getModalChromeLabel } from './modal-i18n';

export const MODAL_BODY_CLASS = 'alteia-tfcs-modal-open';

export const ICON_BASE = '/wp-content/themes/alteia/assets/src/images/icons/';

export const MODAL_ICONS_BY_VARIANT = {
	fund: {
		region: `${ ICON_BASE }fund-region.svg`,
		facilityType: `${ ICON_BASE }fund-facility-type.svg`,
		typicalTenor: `${ ICON_BASE }fund-typical-tenor.svg`,
		commodity: `${ ICON_BASE }fund-commodity.svg`,
	},
	capital: {
		region: `${ ICON_BASE }fund-region.svg`,
		facilityType: `${ ICON_BASE }capital-facility-type.svg`,
		typicalTenor: `${ ICON_BASE }capital-typical-tenor.svg`,
		commodity: `${ ICON_BASE }capital-commodity.svg`,
	},
};

export const MODAL_ICONS = {
	...MODAL_ICONS_BY_VARIANT.fund,
	close: `${ ICON_BASE }modal-close.svg`,
};

/**
 * Case study meta field definitions.
 * Labels are gettext-wrapped so frontend/editor can translate them.
 *
 * @return {Array<Object>} Info field config.
 */
export function getInfoFields() {
	return [
		{
			key: 'region',
			label: getModalChromeLabel( 'region', __( 'Region', 'alteia' ) ),
			inspectorLabel: __( 'Region', 'alteia' ),
			iconKey: 'region',
			iconIdKey: 'regionIconId',
			iconUrlKey: 'regionIconUrl',
			iconLabel: __( 'Region Icon', 'alteia' ),
		},
		{
			key: 'facilityType',
			label: getModalChromeLabel(
				'facilityType',
				__( 'Facility type', 'alteia' )
			),
			inspectorLabel: __( 'Facility Type', 'alteia' ),
			iconKey: 'facilityType',
			iconIdKey: 'facilityTypeIconId',
			iconUrlKey: 'facilityTypeIconUrl',
			iconLabel: __( 'Facility Type Icon', 'alteia' ),
		},
		{
			key: 'typicalTenor',
			label: getModalChromeLabel(
				'typicalTenor',
				__( 'Typical tenor', 'alteia' )
			),
			inspectorLabel: __( 'Typical Tenor', 'alteia' ),
			iconKey: 'typicalTenor',
			iconIdKey: 'typicalTenorIconId',
			iconUrlKey: 'typicalTenorIconUrl',
			iconLabel: __( 'Typical Tenor Icon', 'alteia' ),
		},
		{
			key: 'commodity',
			label: getModalChromeLabel(
				'commodity',
				__( 'Commodity', 'alteia' )
			),
			inspectorLabel: __( 'Commodity', 'alteia' ),
			iconKey: 'commodity',
			iconIdKey: 'commodityIconId',
			iconUrlKey: 'commodityIconUrl',
			iconLabel: __( 'Commodity Icon', 'alteia' ),
		},
	];
}

/** @deprecated Prefer getInfoFields() so labels resolve in the active locale. */
export const INFO_FIELDS = getInfoFields();
